module.exports = __webpack_public_path__ + "static/media/fix_audi.457e296a.png";